module.exports = __webpack_public_path__ + "static/media/bass-clef-header.92c25a87.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/bass-clef-header.svg
// module id = 43
// module chunks = 0